import { memo, useCallback } from 'react';

import { ChevronLeftIcon } from '@air/design-icons';

import { preserveWorkspaceAgentComposerFocus } from '~/components/v2/components/workspace/workspace-agent-panel/utils/preserveWorkspaceAgentComposerFocus';

export type WorkspaceAgentActionsMenuBackRowProps = {
  label: string;
  onBack: () => void;
};

export const WorkspaceAgentActionsMenuBackRow = memo(({ label, onBack }: WorkspaceAgentActionsMenuBackRowProps) => {
  const handleClick = useCallback(() => {
    onBack();
  }, [onBack]);

  return (
    <div className="flex shrink-0 flex-col justify-center ads:bg-subtle bg-gray-3 px-1.5 py-0.5">
      <button
        className="flex w-full items-center gap-2 rounded-6 px-2 py-1.5 text-left font-medium ads:text-primary text-12 text-gray-12 leading-4 ads:hover:bg-hover-subtle hover:bg-gray-4"
        data-testid="WORKSPACE_AGENT_ACTIONS_MENU_BACK"
        onClick={handleClick}
        onMouseDown={preserveWorkspaceAgentComposerFocus}
        type="button"
      >
        <ChevronLeftIcon aria-hidden className="size-4 shrink-0 ads:text-icon-emphasis" />
        {label}
      </button>
    </div>
  );
});

WorkspaceAgentActionsMenuBackRow.displayName = 'WorkspaceAgentActionsMenuBackRow';
